import React, { useMemo, useRef } from "react";
import { Form, Select, Typography, Spin } from "antd";
import { debounce } from "lodash";
const { Option } = Select;
const { Text } = Typography;

const ApiSelect = ({
    label,
    name,
    rules,
    placeholder = "Select an option",
    onClick,
    onSearch,
    onScrollBottom,
    options = [],
    dropdownStatus = "loaded", // 'loading', 'loaded', 'noData'
    dropdownRender,
    allowClear = false,
    disabled = false,
    onSelect,
    mode,
    tagRender,
    rootClassName = "",
    onDeselect,
    isNext,
    className,
    readOnly
}) => {


    const dropdownRef = useRef(null);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollTop + clientHeight >= scrollHeight - 20) {
            onScrollBottom?.();
        }
    };

    const defaultDropdown = (menu) => (
        <div
            ref={dropdownRef}
            onScroll={handleScroll}
            style={{ maxHeight: 200, overflowY: "auto", padding: 4 }}
        >
            {options.length > 0 ? (
                menu
            ) : (
                dropdownStatus !== "loading" && (
                    <div style={{ textAlign: "center", padding: 8 }}>
                        <Text type="secondary">No data found</Text>
                    </div>
                )
            )}
            {dropdownStatus === "loading" && (
                <Spin style={{ display: "block", textAlign: "center", padding: 10 }} />
            )}
        </div>
    );

    const debouncedSearch = useMemo(
        () => debounce((value) => onSearch?.(value), 500),
        [onSearch]
    );
    return (
        <Form.Item label={label} name={name} rules={rules} colon={false} >

            <Select
                // tagRender={tagRender}
                // className={"api_select"}
                placeholder={placeholder}
                showSearch
                // onClick={onClick}
                onSearch={debouncedSearch}
                filterOption={false}
                allowClear={allowClear}
                rootClassName={`${mode === "multiple" && "api_select p-0-multiSelect"} ${rootClassName}`}
                onSelect={onSelect}
                disabled={disabled}
                mode={mode}
                onDropdownVisibleChange={(open) => {
                    if (open) {
                        onClick?.(); // your API call here
                    }
                }}
                onDeselect={onDeselect}
                dropdownRender={(menu) =>
                    dropdownRender ? dropdownRender(menu, handleScroll) : defaultDropdown(menu)
                }
                getPopupContainer={(trigger) => trigger.parentNode}
            >
                {options.map((option) => (
                    <Option key={option.value} value={option.value}>
                        <Text>{option.label}</Text>
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default ApiSelect;
